import * as React from "react";
import { motion } from "framer-motion";
import arrow from "../../../assets/advantageArrow.png";
const Advantage = () => {
  return (
    <>
      <section className="mt-20 text-3xl sm:text-5xl font-medium leading-10 text-center light-title capitalize max-md:mt-10 max-md:max-w-full">
        The Expertefy Advantage
        <p className="mt-2.5 text-lg text-center text-color font-lighter text-[18px] p-5">
          At Expertefy, we merge deep market understanding with agile
          connectivity to provide an unrivaled <br /> expert network service. Here's
          what sets us apart:
        </p>
      </section>
      <section className="flex justify-center items-center w-full max-md:px-5 max-md:mt-2 max-md:max-w-full  mb-[100px] lg:mb-32 max-md:mb-16">
        <div className="flex flex-col w-full w-full container">
          <div>
            <section className="mt-6 w-full max-md:max-w-full">
              <div className="flex gap-5 max-md:flex-col max-md:gap-0">
                <div className="flex flex-col w-6/12 max-md:ml-0 max-md:w-full">
                  <motion.div className="relative flex flex-col grow justify-start py-px w-full text-lg leading-5 text-white bg-light-indigo rounded-xl max-md:mt-8 max-md:max-w-full"
                    initial={{ opacity: 0, scale: 0.5 }}
                    whileInView={{ opacity: 1, scale: 1 }}
                    transition={{ duration: 0.5, delay: 0.5, type: "spring" }}
                    viewport={{ once: true }}>
                    <div className="background">
                      <img
                        alt="Precision-Paired Proficiency Background"
                        src={arrow}
                        className="object-cover absolute inset-0 size-full"
                      />
                    </div>
                    <div className="overflow-hidden relative z-10 flex-col justify-start p-4 w-full min-h-[100px] max-md:max-w-full">
                      <h2 className="text-xl font-medium text-white mb-2">
                        | Precision-Paired Proficiency
                      </h2>
                      <span className="leading-5">
                        Every expert in our network is rigorously screened,
                        ensuring a perfect match to your precise industry and inquiry
                        needs.
                      </span>
                    </div>
                  </motion.div>
                </div>
                <div className="flex flex-col ml-5 w-6/12 max-md:ml-0 max-md:w-full">
                  <motion.div className="relative flex flex-col grow justify-center py-px w-full text-lg leading-5 text-white bg-dark-indigo rounded-xl max-md:mt-8 max-md:max-w-full"
                    initial={{ opacity: 0, scale: 0.5 }}
                    whileInView={{ opacity: 1, scale: 1 }}
                    transition={{ duration: 0.5, delay: 0.6, type: "spring" }}
                    viewport={{ once: true }}>

                    <div className="background">
                      <img
                        alt="Accelerated Insight Access Background"
                        src={arrow}
                        className="object-cover absolute inset-0 size-full"
                      />
                    </div>

                    <div className="overflow-hidden relative z-10 flex-col justify-center p-4 w-full min-h-[100px] max-md:max-w-full mb-2">
                      <h2 className="text-xl font-medium text-white mb-2">
                        | Accelerated Insight Access
                      </h2>
                      <span className="leading-5">
                        Our operations span time zones, promising swift delivery
                        of critical expertise so you can capitalize on evolving
                        market dynamics instantly.
                        
                      </span>
                    </div>
                  </motion.div>
                </div>
              </div>
            </section>
            <section className="mt-6 w-full max-md:max-w-full">
              <div className="flex gap-5 max-md:flex-col max-md:gap-0">
                <div className="flex flex-col w-6/12 max-md:ml-0 max-md:w-full">
                  <motion.div className="relative flex flex-col grow justify-start w-full text-white bg-dark-indigo rounded-xl max-md:mt-8 max-md:max-w-full"
                    initial={{ opacity: 0, scale: 0.5 }}
                    whileInView={{ opacity: 1, scale: 1 }}
                    transition={{ duration: 0.5, delay: 0.7, type: "spring" }}
                    viewport={{ once: true }}>
                    <div className="background">
                      <img
                        alt="Comprehensive Coverage Background"
                        src={arrow}
                        className="object-cover absolute inset-0 size-full"
                      />
                    </div>
                    <div className="relative overflow-hidden relative flex-col justify-center p-4 w-full min-h-[100px] max-md:max-w-full">
                      <h2 className="text-xl font-medium text-white mb-2">
                        | Comprehensive Coverage
                      </h2>
                      <span className="leading-5 text-lg">
                        Whether it's expansive market landscapes or specific industry niches, our scalable network delivers the right volume
                        and caliber of expertise.
                      </span>
                    </div>
                  </motion.div>
                </div>
                <div className="flex flex-col ml-5 w-6/12 max-md:ml-0 max-md:w-full">
                  <motion.div className="relative flex flex-col grow justify-start w-full text-lg leading-5 text-white bg-light-indigo rounded-xl max-md:mt-8 max-md:max-w-full"
                    initial={{ opacity: 0, scale: 0.5 }}
                    whileInView={{ opacity: 1, scale: 1 }}
                    transition={{ duration: 0.5, delay: 0.7, type: "spring" }}
                    viewport={{ once: true }}>
                    <div className="background">
                      <img
                        alt="Unmatched Flexibility Background"
                        src={arrow}
                        className="object-cover absolute inset-0 size-full"
                      />
                    </div>
                    <div className="overflow-hidden relative flex-col justify-center p-4 w-full min-h-[100px] max-md:max-w-full mb-2">
                      <h2 className="text-xl font-medium text-white mb-2">
                        | Unmatched Flexibility
                      </h2>
                      <span className="leading-5">
                        Your business is dynamic; so are we.{" "} <span className="leading-8 uppercase">Expertefy</span>{" "}
                        offers adaptable engagement models to seamlessly fit your
                        evolving project and budgetary needs.
                      </span>
                    </div>
                  </motion.div>
                </div>
              </div>
            </section>
            <section className="mt-6 w-full max-md:max-w-full">
              <div className="flex gap-5 max-md:flex-col max-md:gap-0">
                <div className="flex flex-col w-6/12 max-md:ml-0 max-md:w-full">
                  <motion.div className="relative flex flex-col grow justify-start w-full text-white bg-light-indigo rounded-xl max-md:mt-8 max-md:max-w-full"
                    initial={{ opacity: 0, scale: 0.5 }}
                    whileInView={{ opacity: 1, scale: 1 }}
                    transition={{ duration: 0.5, delay: 0.8, type: "spring" }}
                    viewport={{ once: true }}>
                    <div className="background">
                      <img
                        alt="Global Reach, Personal Touch Background"
                        src={arrow}
                        className="object-cover absolute inset-0 size-full"
                      />
                    </div>
                    <div className="overflow-hidden relative flex-col justify-center p-4 w-full min-h-[100px] max-md:max-w-full">
                      <h2 className="text-xl font-medium text-white mb-2">
                        | Global Reach, Personal Touch
                      </h2>
                      <span className="leading-5 text-lg">
                        Our extensive network spans continents, but our service
                        is intimately tailored to your unique challenges.
                      </span>
                    </div>
                  </motion.div>
                </div>
                <div className="flex flex-col ml-5 w-6/12 max-md:ml-0 max-md:w-full">
                  <motion.div className="relative flex flex-col grow justify-start w-full text-lg leading-5 text-white bg-dark-indigo rounded-xl max-md:mt-8 max-md:max-w-full"
                    initial={{ opacity: 0, scale: 0.5 }}
                    whileInView={{ opacity: 1, scale: 1 }}
                    transition={{ duration: 0.5, delay: 0.9, type: "spring" }}
                    viewport={{ once: true }}>
                    <div className="background">
                      <img
                        alt="Trust Through Transparency Background"
                        src={arrow}
                        className="object-cover absolute inset-0 size-full"
                      />
                    </div>
                    <div className="overflow-hidden relative flex-col justify-center p-4 w-full min-h-[100px] max-md:max-w-full mb-2">
                      <h2 className="text-xl font-medium text-white">
                        | Trust Through Transparency
                      </h2>
                      <br />
                      <span className="leading-5">At </span>
                      <span className="leading-5 uppercase">Expertefy</span>
                      <span className="leading-5">
                        , trust is paramount. Our commitment to clear, honest communication ensures that our partnership is
                        always aligned with your best interests.
                      </span>
                    </div>
                  </motion.div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </section>
    </>
  );
};

export default Advantage;
